import * as types from '../constants/actionTypes';
import * as Rx from 'rxjs';
const {Observable} = Rx;
const {of, ajax} = Observable;
import * as actions from '../actions/userActions';
const apiUrls = require('../constants/apiUrls');
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
    call: (fn, ...args) => fn(...args)
};

export const api = {
    getUserInfo: () => ajax({
        url: `https://wow.okta.com/oauth2/v1/userinfo`,
        method: 'get',
        responseType: '',
        crossDomain: true,
        timeout: apiUrls.API_TIMEOUT,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'authorization': 'Bearer '
        }
    }),
    getTechInfo: (userId, store) => {

        const state = store.getState();
        const accessToken = getAccessTokenFromState(state);

        const wowHeaders = wowCustomHeader(state);

        return ajax({
            url: `${apiUrls.TECH_GET_INFO_URL}/${userId}`,
            method: 'get',
            responseType: 'application/json',
            crossDomain: true,
            timeout: apiUrls.API_TIMEOUT,
            headers: {
                ...wowHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
                'authorization': 'Bearer ' + accessToken
            }
        });
    }
};

export const userInfoEpic = (action$, store, call = indirect.call) => action$
    .ofType(types.USER_INFO_LOAD_STARTED)
    .mergeMap(() => call(api.getUserInfo, store).map(payload => {
        let result = {};
        if (payload.response) {
            result = JSON.parse(payload.response);
        }
        return (actions.userInfoLoadFinished(result));
    }).catch(error => of(actions.userInfoLoadFailed(error))));

export const techInfoEpic = (action$, store, call = indirect.call) => action$
    .ofType(types.GET_TECH_INFO_STARTED)
    .mergeMap(action => call(api.getTechInfo, action.id, store).map(payload => {
        let result = {};
        if (payload.response) {
            result = JSON.parse(payload.response);
        }
        return (actions.getTechInfoFinished(result));
    }).catch(error => of(actions.getTechInfoFailed(error))));



// WEBPACK FOOTER //
// ./src/epics/userEpics.js